import { render, staticRenderFns } from "./GemeosObito.vue?vue&type=template&id=363a5190&"
import script from "./GemeosObito.vue?vue&type=script&lang=js&"
export * from "./GemeosObito.vue?vue&type=script&lang=js&"
import style0 from "./GemeosObito.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports